import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { Observable } from 'rxjs/Observable';
import { Route, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { AuthService } from '../service/auth.service';
// import { UARService } from '../service/uar.service';
import { environment } from '@environment/environment';
import { AdminService } from '@adminservice/admin.service';

  
@Injectable()

export class authManager implements CanActivate {
    map: any;
    indexAccessToken: number;
    indexAuthCode: number;
    indexTokenType: number;
    accessTokenStr: string;
    authCodeStr: string;
    urlLength: number;
    access_code: string = '-1';
    public dynSSOId = '-1';
    // Initiate variables for storing user info
    // var dynIpAddress = 'undefined';
    public dynEmail = '';
    public dynFirstName = '';
    public dynLastName = '';
    public dynDeptName = '';
    userGroups = '';
    dynBusiness = '';
    dynSubBusiness = '';
    dynEmpTitle = '';
    dynTimeToExpire = '';
    access_token = '-1';
    authType = '';
    storedAccessTokenIssueDate = sessionStorage.getItem('access_token_issuedate');
    accessTokenIssueDate = new Date(this.storedAccessTokenIssueDate);
    currentDate = new Date();
    tokenTimeoutMins = 120 - 5;
    accessTokenTimeoutDate: Date = this.accessTokenIssueDate;
    baseurl = environment.stage.appurl;
    referenceUrl: string;
    // buffer for timing out

    userDetailsFromDb: any;

        constructor(private router: Router, private authService: AuthService, private adminService: AdminService) {
        this.indexAccessToken = window.location.href.indexOf('access_token');
        this.indexAuthCode = window.location.href.indexOf('code');
        this.indexTokenType = window.location.href.indexOf('&token_type');
        this.accessTokenStr = 'access_token=';
        this.authCodeStr = 'code=';



        if (this.accessTokenTimeoutDate != null) {
            this.accessTokenTimeoutDate.setMinutes(this.accessTokenTimeoutDate.getMinutes() + this.tokenTimeoutMins);
        }
    }


    canActivate(route: ActivatedRouteSnapshot, test: RouterStateSnapshot): any {
        let self = this;
        if (!(window.location.href.indexOf('localhost') > 0)) {
             debugger;
            if (this.indexAuthCode > -1) {
                const search = window.location.href.split('?')[1];
            let queryParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
            this.access_code =queryParams['code'];

               // this.access_code = window.location.href.substring(this.indexAuthCode + this.authCodeStr.length, this.urlLength);
                return this.authService.getToken(this.access_code).toPromise().then(result => {
                    debugger;
                    this.access_token = result.access_token;
                    sessionStorage.setItem('access_token', this.access_token);
                    sessionStorage.setItem('access_token_issuedate', this.currentDate.toString());
                    sessionStorage.setItem('access_token_expires', result.expires_in);
                    sessionStorage.setItem('id_token', result.id_token);
                }).then(function () {
                    debugger;

                    return self.setUserDetailsAsync().then(result => {
                       // self.dynSSOId = result.access_token.uid;
                        self.dynSSOId = result.SSO;
                        self.dynFirstName = result.FirstName;
                        self.dynLastName = result.LastName;
                    }).then(function () {

                        return self.adminService.getUserDetailsFromSSOId(self.dynSSOId).toPromise().then(
                            p => {

                                self.userDetailsFromDb = p;
                                if (self.userDetailsFromDb != null) {
                                    sessionStorage.setItem('userid', self.userDetailsFromDb.userID);
                                    sessionStorage.setItem('firstname', self.userDetailsFromDb.firstName);
                                    sessionStorage.setItem('lastname', self.userDetailsFromDb.lastName);
                                    sessionStorage.setItem('emailid', self.userDetailsFromDb.emailID);
                                    sessionStorage.setItem('userRoleId', self.userDetailsFromDb.userRoleID);
                                    sessionStorage.setItem('userType', 'I');
                                    sessionStorage.setItem('token', self.userDetailsFromDb.token);
                                    
                                    return true;
                                }

                                else {
                                    self.router.navigate(['Header']);
                                }

                            }) .catch((err) => { 
                console.log(err);
                //reject(err); // Here.
            });

                    });
                });

            } else if ((this.dynSSOId === '-1' && !sessionStorage.getItem('access_token')) || (this.storedAccessTokenIssueDate !== null && this.currentDate >= this.accessTokenTimeoutDate)) {

                sessionStorage.setItem('referenceUrl', window.location.href);
                //window.location.replace(environment.stage.authUrl + 'oauth/authorize?client_id=' + environment.stage.clientId + '&redirect_uri=' + this.baseurl + '&response_type=code');
                
                window.location.replace(environment.stage.MsauthUrl + '?client_id=' + environment.stage.MsAuthclientId + '&response_type=code' +'&redirect_uri=' + this.baseurl +'&scope=openid profile');
                return new Observable<any>();
            } else if (sessionStorage.getItem('access_token') && this.dynSSOId === '-1') {

                return this.setUserDetailsAsync().then(result => {

                    this.dynSSOId = result.SSO;
                    this.dynFirstName = result.FirstName;
                    this.dynLastName = result.LastName;
                }).then(function () {

                    return self.adminService.getUserDetailsFromSSOId(self.dynSSOId).toPromise().then(
                        p => {

                            self.userDetailsFromDb = p;
                            if (self.userDetailsFromDb != null) {
                                sessionStorage.setItem('userid', self.userDetailsFromDb.userID);
                                sessionStorage.setItem('firstname', self.userDetailsFromDb.firstName);
                                sessionStorage.setItem('lastname', self.userDetailsFromDb.lastName);
                                sessionStorage.setItem('emailid', self.userDetailsFromDb.emailID);
                                sessionStorage.setItem('userRoleId', self.userDetailsFromDb.userRoleID);
                                sessionStorage.setItem('userType', 'I');
                                sessionStorage.setItem('token', self.userDetailsFromDb.token);
                                return true;
                            }

                            else {
                                self.router.navigate(['Header']);
                            }
                        });

                });


            } else if (this.dynSSOId === '-1' && !sessionStorage.getItem('access_token')) {

                this.router.navigate(['']);
                return new Observable<any>();
            } else { return new Observable<any>(); }
        } else {

            this.dynLastName = 'Acharya';
			/*this.dynFirstName='Ananad';
            this.dynSSOId="502155735"; */
            this.dynFirstName = 'Arvind';
            this.dynSSOId = "206578557";  //206580072 //206577911 //206583290 AJ //206549677 JO //206578558
            sessionStorage.setItem('SSO', this.dynSSOId);

            return this.adminService.getUserDetailsFromSSOId(this.dynSSOId).toPromise().then(
                //this.adminService.getUserDetailsFromSSOId(this.dynSSOId).subscribe(  
                p => {
                    this.userDetailsFromDb = p;
                    if (this.userDetailsFromDb != null) {
                        sessionStorage.setItem('userid', this.userDetailsFromDb.userID);
                        sessionStorage.setItem('firstname', this.userDetailsFromDb.firstName);
                        sessionStorage.setItem('lastname', this.userDetailsFromDb.lastName);
                        sessionStorage.setItem('emailid', this.userDetailsFromDb.emailID);
                        sessionStorage.setItem('userRoleId', this.userDetailsFromDb.userRoleID);
                        sessionStorage.setItem('userType', 'I');
                        sessionStorage.setItem('token', this.userDetailsFromDb.token);

                        return true;
                    }

                    else {
                        this.router.navigate(['Header']);
                    }
                });



        }

    }


    public logoutUser() {

        this.dynFirstName = '';
        this.dynLastName = '';
        this.dynSSOId = '';
        this.dynEmail = '';

        let userType = sessionStorage.getItem('userType');

        sessionStorage.clear();
        sessionStorage.removeItem('access_token');

        sessionStorage.removeItem('access_token_issuedate');

        sessionStorage.removeItem('access_token_expires');

        sessionStorage.removeItem('userid');

        sessionStorage.removeItem('firstname');

        sessionStorage.removeItem('lastname');

        sessionStorage.removeItem('emailid');
        sessionStorage.removeItem('userRoleId');
        localStorage.clear();
 

        sessionStorage.setItem('userType', userType);
        userType = sessionStorage.getItem('userType');

        if (userType === 'E') {
            sessionStorage.removeItem('userType');
            window.location.href = environment.stage.appurl + '/#/Login';
        } else {
             sessionStorage.removeItem('userType');
            window.location.href = environment.stage.logoutUri + environment.stage.appurl + '%26client_id=' + environment.stage.MsAuthclientId;
        }

        sessionStorage.clear();
        localStorage.clear();
        
       
        
    }
    private decodeJwtToken() {
        const id_token = sessionStorage.getItem('id_token');
        const decodedToken = JSON.parse(atob(id_token.split('.')[1]));;
        return decodedToken;
        
 
      }
      
      private async setUserDetailsAsync() {
        const details = this.decodeJwtToken();
         let currentUser;
         try {
           let sso = details.preferred_username.split('@');
          
               currentUser = {
               FirstName: details.given_name,
               LastName: details.family_name,
               Email: details.preferred_username,
               SSO: sso[0]
             };
             
           }
          catch (error) {
           console.log(error);
         }

         return currentUser;
       }

}



// WEBPACK FOOTER //
// ./src/app/helpers/authManager.ts